
import { getOrganization } from './getOrganization';
import { updateOrganization } from './updateOrganization';


export default {
    getOrganization,
    updateOrganization
};
